// extracted by mini-css-extract-plugin
module.exports = {"text-regular":"14px","listHeading":"ListHeading-module--listHeading--205469"};